import React from 'react';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import GenericButton from './GenericButton';
import PortalModal from './Modal/PortalModal';

const validateTrendModalStyle = {
  width: '50%',
  left: '30%',
  top: '12%',
};

const ValidateTrendModal = props => {
  const { show, modalData, handleCancel, handleComplete, trendStudies } = props;
  const baseArr = [];
  const studyColRowList = [];
  if (modalData.length !== trendStudies.length) {
    modalData.pop();
  }
  // for base List
  modalData.forEach(
    row =>
      row.baseList &&
      row.baseList.forEach(
        res =>
          !res.valid &&
          baseArr.push({
            id: res.expression,
            label: res.label,
            gridType: 'Bases',
          })
      )
  );

  modalData.forEach((row, i) => {
    const colData = [];
    const rowData = [];
    // for col list
    if (row.colList.length > 0) {
      row.colList.forEach(
        res =>
          !res.valid &&
          colData.push({
            id: res.expression,
            label: res.label,
            gridType: 'Columns',
          })
      );
    }

    // for row list
    if (row.rowList.length > 0) {
      row.rowList.forEach(
        res =>
          !res.valid &&
          rowData.push({
            id: res.expression,
            label: res.label,
            gridType: 'Rows',
          })
      );
    }

    // combine row col list
    if (colData.length > 0 || rowData.length > 0) {
      studyColRowList.push({
        study: trendStudies[i] && trendStudies[i].sd,
        label: [...colData, ...rowData],
      });
    }
  });

  const renderData = (title, gridList) => {
    if (gridList.length > 0) {
      return (
        <div key={uuid()}>
          <h4>
            <b>{`${title}`}:</b>
          </h4>
          {title === 'Bases' ? (
            <div
              key={`${gridList[0].id}+${uuid()}`}
            >{`${gridList[0].label}`}</div>
          ) : (
            gridList.map(data => (
              <div key={`${data.id} +${uuid()}`}>
                <div key={`${data.id} +${uuid()}`}>{`${data.label}`}</div>
              </div>
            ))
          )}
        </div>
      );
    }
    return <div />;
  };
  return (
    <div>
      <PortalModal
        isShowing={show}
        title="Validate Study Results"
        dialogStyles={validateTrendModalStyle}
        onCloseClicked={handleCancel}
      >
        <div className="row margin-0">
          <h4>The following items are not available</h4>
        </div>
        <div className="row invalid-grid-data">
          {baseArr.length > 0 && renderData('Bases', baseArr)}
          {studyColRowList.length > 0 &&
            studyColRowList.map(res => renderData(res.study, res.label))}
        </div>
        <div className="modal-footer">
          <GenericButton
            name="Cancel"
            btnStyle="pull-left validate-modal-cancel"
            onBtnClick={handleCancel}
          />
          <GenericButton
            name="Complete"
            btnStyle="pull-right validate-modal-complete"
            onBtnClick={() => handleComplete(modalData)}
          />
        </div>
      </PortalModal>
    </div>
  );
};

ValidateTrendModal.propTypes = {
  show: PropTypes.bool,
  handleComplete: PropTypes.func,
  handleCancel: PropTypes.func,
  trendStudies: PropTypes.arrayOf(PropTypes.object),
  modalData: PropTypes.arrayOf(PropTypes.object),
};

export default ValidateTrendModal;
